<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Team</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Team</v-btn>
        </template>
        <v-card v-if="isAllowedNewTeam()">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.team_name"
                      :rules="[(v) => !!v || 'This field is required!']"
                      label="Team Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.numbers_of_dasher"
                      label="Number of Dasher"
                      :rules=[rules.required,checkTeamMemberLimit]
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <span class="headline">Team creation limit exceed</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <p>Please subscribe premium or corporate package</p>
                <br />
                <router-link to="/subscription-package"
                  ><p>click here to go to subscription page</p></router-link
                >
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.teams"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.team_name }}</td>
        <td class="text-xs-center">{{ props.item.team_code }}</td>
        <td class="text-xs-center">{{ props.item.team_active_status }}</td>
        <td class="text-xs-center">{{ props.item.numbers_of_dasher }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import utilities from "../../../api/utilities.js";

export default {
  data: () => ({
    dialog: false,
    search: "",
    apiUrl: "team",
    valid: true,
    headers: [
      { text: "id", align: "center", value: "id" },
      { text: "Team Name", align: "center", value: "team_name" },
      { text: "Team Code", align: "center", value: "team_code" },
      { text: "Team status", align: "center", value: "team_active_status" },
      {
        text: "Numbers of Dasher",
        align: "center",
        sortable: false,
        value: "numbers_of_dasher",
      },
    ],
    editedIndex: -1,
    editedItem: {
      team_name: "",
      numbers_of_dasher: "",
    },
    defaultItem: {
      team_name: "",
      numbers_of_dasher: "",
    },
    rules: {
      required: v => !!v || 'this field is required',
    }
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Team" : "Edit Team";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.teams.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.teams.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.teams.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },
    isAllowedNewTeam() {
      let allowedTeam = utilities.maximumNumberOfTeam(
        this.subscriptionData.subscriptionFeatures
      );
      if (allowedTeam) {
        if (this.getIndexDataLength() < allowedTeam) {
          return true;
        } else {
          return false;
        }
      }
    },

    checkTeamMemberLimit(value) {
      var maxLimit = utilities.maximumNumberOfTeamMembers(
        this.subscriptionData.subscriptionFeatures
      )  
      if (value > maxLimit) {
        return `Maximum allowed limit ${maxLimit}`;
       } else {
         return true;
       }    
    },

    getIndexDataLength() {
      if (this.indexData.teams) {
        return Object.keys(this.indexData.teams).length;
      } else {
        return 0;
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          // console.log('success');
          this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        } else {
          this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        }
        this.close();
      }
    },
  },
};
</script>
